import type { NextPage } from "next";

import PageLayout from "@components/PageLayout";

import Dashboard from "@components/Dashboard-v2";

const DashboardPage: NextPage = () => {
  return (
    <>
      <PageLayout extraMarginTop={false}>
        <Dashboard />
      </PageLayout>
    </>
  );
};

export default DashboardPage;
